import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import './App.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import { AppNavbar } from './components/navbar';
import { CloakedAdminView } from './views/adminview';
import { FormViewV2 } from './views/formviewV2';
import { ReactKeycloakProvider, useKeycloak } from '@react-keycloak/web';
import keycloak from './util/keycloak';
import { Spinner } from 'react-bootstrap';
import { AnalyticsView } from './views/analyticsview';
import { SupportNavbar } from './support/components/navbar';
import { SupportDashboard } from './support/views/supportDashboard';
import { GlobalLoadingOverlay } from './components/loadingOverlay';

const defaultRouter = createBrowserRouter([
  {
    element: <AppNavbar />,
    children: [
      {
        path: '/formv2',
        element: <FormViewV2 />,
      },
      {
        path: '/admin',
        element: <CloakedAdminView />
      },
      {
        path: '/analytics',
        element: <AnalyticsView />
      },
      {
        path: '*',
        element: <Navigate to="/formv2" />
      }
    ]
  },
])

const supportRouter = createBrowserRouter([
  {
    element: <SupportNavbar />,
    children: [
      {
        index: true,
        element: <SupportDashboard />
      },
    ],
  }
])

function App() {
  const { initialized } = useKeycloak()

  if (!initialized) {
    return <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  }

  let router = defaultRouter
  if (window.location.hostname.split('.')[0] === 'support') {
    router = supportRouter
  }

  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

const CloakedApp = () => (
  <ReactKeycloakProvider authClient={keycloak}>
    <GlobalLoadingOverlay />
    <App />
  </ReactKeycloakProvider>
)

export default CloakedApp;
